function i(t){return t==null||typeof t!="object"&&typeof t!="function"}export{i as isPrimitive};
